export const debounce = {
  methods: {
    debounce(callback, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => callback(), delay);
    },
  },
  data() {
    return {
      timer: null,
    };
  },
};
